module.exports = __webpack_public_path__ + "img/全部提交.a071befc.svg";